import { createBackdrop, removeBackdrop } from './backdrop.js';

let headerInitialized = false;
let api = null;

const initHeader = () => {

    if (headerInitialized) return api;
    headerInitialized = true;

    // console.log("initHeader.js");

    const bodyElm = document.querySelector('body');
    if (!bodyElm) return;

    /* ========================= Menu ========================= */
    const closeMenu = () => {
        if (bodyElm.classList.contains('menu--open')) {
            bodyElm.classList.remove('menu--open', 'overflow--hidden');
            bodyElm.style.paddingRight = '0';
            removeBackdrop('backdrop');
            // removeBackdrop('submenu-backdrop');
            // closeAllSubmenus();
        }
    };

    const toggleMenu = () => {
        const isOpen = bodyElm.classList.contains('menu--open');

        console.log('toggle menu, isOpen:', isOpen);
        if (isOpen) {
            console.log('closing menu');
            closeMenu();
        } else {
            console.log('opening menu');
            bodyElm.classList.add('menu--open', 'overflow--hidden');
            bodyElm.style.paddingRight = window.innerWidth - bodyElm.clientWidth + 'px';
            createBackdrop('[data-overlay-wrapper]', closeMenu, 'backdrop fade');
        }
    };

    const initMenuToggle = () => {
        document.addEventListener('click', (e) => {
            if (e.target.closest('[data-menu-trigger]')) {
                e.preventDefault();
                e.stopPropagation();
                toggleMenu();
            }

            if (e.target.closest('[data-menu-close]')) {
                e.preventDefault();
                closeMenu();
            }

            if (e.target.closest('.backdrop')) {
                e.preventDefault();
                closeMenu();
            }
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth >= 1280) {
                closeMenu();
            }
        });
    };

    /* ========================= Sticky header on scroll ========================= */
    const initHeaderScrollBehavior = () => {
        const headerStickyElm = document.querySelector('[data-header-sticky]');
        // const headerTop = document.querySelector('.header__top');
        if (!headerStickyElm) return;

        // const threshold = headerTop.offsetHeight;

        let lastScrollY = window.scrollY;
        let lastScrollYLast = window.scrollY;


        window.addEventListener('scroll', () => {
            // headerSticky.classList.toggle('header__scroll', window.scrollY > threshold);

            lastScrollY = window.scrollY;
            // headerStickyElmHeight = headerStickyElm.offsetHeight;
            // langElm.classList.remove('open');

            if (lastScrollY > lastScrollYLast) {
                // console.log('down')
                headerStickyElm.classList.remove('header--pin');
                if (lastScrollY > 0) {
                    headerStickyElm.classList.add('header--scroll');
                    // headerStickyElm.classList.remove('header__pin');

                    // bodyElm.classList.remove('menu--open', 'search--open', 'catalog--open', 'overflow--hidden');
                    // bodyElm.style.paddingRight = '0';
                    // document.querySelector('.backdrop').remove();
                    // hideBackdropBlock();
                }
            } else {
                // console.log('up')
                headerStickyElm.classList.add('header--pin');

                if (lastScrollY <= 10) {
                    headerStickyElm.classList.remove('header--scroll');
                    // headerStickyElm.classList.remove('header__pin');
                }
                if (lastScrollY <= 1) {
                    headerStickyElm.classList.remove('header--pin');
                    // headerStickyElm.classList.remove('header__pin');
                }
            }
            lastScrollYLast = lastScrollY;

        });
    };

    /* ========================= Init all ========================= */

    initMenuToggle();
    initHeaderScrollBehavior();

    api = { toggleMenu, closeMenu };
    return api;
};

export default initHeader;
